import {
  CREATELEADTASK,
  GETLEADTASK,
  DELETELEADTASK,
  UPDATELEADTASK,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETLEADTASK:
      return {
        ...state,
        leadTaskList: action.payload.data,
      };
    case UPDATELEADTASK:
      return {
        ...state,
        leadTaskUpdateStatus: action.payload.success,
      };

    case DELETELEADTASK:
      return {
        ...state,
        leadTaskList: state.leadTaskList.filter(
          (item) => item.task_id !== action.leadTaskId,
        ),
        leadTaskDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
